module.exports = __webpack_public_path__ + "img/bear.6095fb70.svg";